/* Sooler Studio: enable the native header overlay only when the hero is first. */
(function () {
  if (window.soolerHeaderOverlayRefresh) {
    window.soolerHeaderOverlayRefresh();
    return;
  }

  var body = document.body;
  var headerSection = document.querySelector('.header-section');
  var header = document.getElementById('header');
  if (!body || !headerSection || !header) return;

  function hasFirstHero() {
    var firstSection = document.querySelector('#main-content > .shopify-section');
    return Boolean(firstSection && firstSection.querySelector('.sooler-hero[data-sooler-header-overlay]'));
  }

  function refresh() {
    var enabled = hasFirstHero();
    body.classList.toggle('sooler-header-overlay', enabled);
    if (!enabled) {
      body.classList.remove('sooler-header-overlay-top');
      return;
    }

    body.classList.toggle('sooler-header-overlay-top', !header.classList.contains('is-sticky') && window.scrollY <= headerSection.offsetTop + 1);
  }

  window.soolerHeaderOverlayRefresh = refresh;
  window.addEventListener('scroll', refresh, { passive: true });
  window.addEventListener('resize', refresh, { passive: true });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', function () { requestAnimationFrame(refresh); });
  new MutationObserver(refresh).observe(header, { attributes: true, attributeFilter: ['class'] });
  refresh();
})();
